import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, IconButton } from 'seagull';
import { Row } from 'seagull/components/Layout';
import { Toast } from 'seagull/components/Toast';
import { Typography } from 'seagull/components/Typography';
import { CloseCross } from 'seagull/icons/essentials';
export function persistentToastContent(props) {
    const { type, message, action, closeLabel, closeBiName, testId, closeTestId, onClose } = props;
    const inner = /*#__PURE__*/ _jsxs(Row, {
        gap: 16,
        alignItems: "center",
        justifyContent: "space-between",
        children: [
            /*#__PURE__*/ _jsxs(Row, {
                gap: 12,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph2",
                        children: message
                    }),
                    action != null && /*#__PURE__*/ _jsx(Button, {
                        skin: "darkSecondary",
                        size: "small",
                        bi: {
                            name: action.biName
                        },
                        testId: action.actionTestId,
                        onClick: action.onAction,
                        children: action.actionLabel
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(IconButton, {
                bi: {
                    name: closeBiName
                },
                skin: "transparent",
                size: "small",
                tooltip: {
                    title: closeLabel
                },
                testId: closeTestId,
                onClick: onClose,
                children: /*#__PURE__*/ _jsx(CloseCross, {
                    size: 16
                })
            })
        ]
    });
    return /*#__PURE__*/ _jsx(Toast, {
        type: type,
        text: inner,
        testId: testId
    });
}
